import type { FlavorConfig, Flavor, Environment } from '@/types/flavor';

// Get current flavor and environment from Vite or defaults
const currentFlavor = (import.meta.env.VITE_FLAVOR as Flavor) || 'sideconvo';
const currentEnv = (import.meta.env.VITE_ENVIRONMENT as Environment) || 'local';

// Dynamic imports based on flavor
const configModules = import.meta.glob<{ default: FlavorConfig }>('./**/config.*.ts', {
  eager: true,
});

// Build configs object dynamically
const configs: Record<Environment, FlavorConfig> = {} as Record<Environment, FlavorConfig>;

// Load configs for current flavor
Object.entries(configModules).forEach(([path, module]) => {
  // Extract flavor and environment from path: ./sideconvo/config.local.ts
  const match = path.match(/\.\/([^/]+)\/config\.([^.]+)\.ts$/);
  if (match) {
    const [, flavor, env] = match;
    if (flavor === currentFlavor) {
      configs[env as Environment] = module.default;
    }
  }
});

// Fallback if no config found for environment
if (!configs[currentEnv]) {
  console.warn(
    `No config found for flavor "${currentFlavor}" and environment "${currentEnv}", falling back to local`
  );
}

export const flavorConfig: FlavorConfig = configs[currentEnv] || configs.local;

// Helper functions
export const getCurrentFlavor = (): Flavor => currentFlavor;
export const getFlavorConfig = (): FlavorConfig => flavorConfig;
